import { createSvgIcon, SvgIconProps } from "@mui/material";
import { FC } from "react";

const BrowseIcon: FC<SvgIconProps> = createSvgIcon(
  <>
    <path
      d="M12.3827 5L18.1228 9.8488L17.3485 10.7655L12.9827 7.07767V15.9593H11.7827V7.07767L7.41694 10.7655L6.64258 9.8488L12.3827 5Z"
      fill="currentColor"
    />
    <path d="M18.5 19H6.5V18H18.5V19Z" fill="currentColor" />
  </>,
  "Browse"
);

export default BrowseIcon;
